<template lang="html">
  <div class="pages-preview-container" v-if="isMounted">
    <ElmPreview :ports="setupPorts" :flags="flags"></ElmPreview>
  </div>
</template>

<script lang="js">
  import expressionBuilder from "@/views/drag-drop-pages/components/utils/expression-builder";
  import { mapState } from "vuex";
  import services from "@/services";
  import Preview from "@/components/Preview.elm";
  import * as WrapElm from "@/components/utils/elmWrapper.js";
  import iconsUri from "@/views/drag-drop-pages/components/utils/icons-uri";
  import i18n from "@/plugins/i18n";
  import {PLATFORMS} from "@/static/global-variables";

  let ports_;

  export default  {
    name: "pages-preview",
    components: {
      ElmPreview: WrapElm(Preview.Elm.Preview)
    },
    props: {
      appId: {
        type: String
      },
      pageName: {
        type: String
      },
      platform: {
        type: String
      }
    },
    watch: {
      platform: function(newVal) {
        ports_?.rxFromFrontEnd.send(
          { platform : newVal,
            iconUrl : this.getIconUrl,
            type: "PlatformSelected"
          }
        );
      }
    },
    computed: {
      ...mapState({
        messages: "messages"
      }),
      appContent() {
        return JSON.parse(JSON.stringify(expressionBuilder.getAppContent(this.appId)));
      },
      hasPages() {
        return Boolean(this.appContent && this.appContent.pages && this.appContent.pages.length);
      },
      i18nMessages() {
        const i18Messages = i18n.messages;
        const locale = i18n.locale || "en_US";
        const defaultMessages = i18Messages[i18n.fallbackLocale] || i18Messages.en || {};
        const messages = i18Messages[locale] || i18Messages[locale.split("_")[0]] || {};
        return {...defaultMessages, ...messages};
      },
      getIconUrl() {
        switch (this.platform) {
          case PLATFORMS.APP:
            return iconsUri.getAppIconUrlForPreview();
          case PLATFORMS.BROWSER:
            return iconsUri.getSLDSIconUrlForPreview();
          default:
            console.log(`${this.platform} is not a valid preview platform.`);
            return "";
        }
      }
    },
    mounted () {
      this.flags = {
        type: "Page",
        pageName: this.pageName,
        veevaMessages: this.messages,
        iconUrl: this.getIconUrl,
        i18n : this.i18nMessages,
        platform: this.platform
      };
      this.isMounted = this.hasPages;
    },
    data () {
      return {
        flags: {},
        isMounted: null
      }
    },
    methods: {
      setupPorts: ports => {
        ports.sendToEngine.subscribe(
            services.getElmCompiler().ports.rxFromPreview.send
        );
        services.getElmCompiler().ports.sendToPreview.subscribe(
            ports.rxFromEngine.send
        );
        ports_ = ports;
      }
    }
  }
</script>

<style scoped lang="scss">
  .pages-preview-container {
    padding: 0.5rem;
  }
</style>